import { render, staticRenderFns } from "./BitrixCallbackButton.vue?vue&type=template&id=c1b3fe74&"
import script from "./BitrixCallbackButton.vue?vue&type=script&lang=js&"
export * from "./BitrixCallbackButton.vue?vue&type=script&lang=js&"
import style0 from "./BitrixCallbackButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports